/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Aria_LabelInputs */

const en_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Shortcut`)
};

const fr_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer le raccourci`)
};

const de_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klare Abkürzung`)
};

const it_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella collegamento`)
};

const ru_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить ярлык`)
};

const es_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar acceso directo`)
};

const zh_cn2_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除快捷方式`)
};

const ja_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートカットをクリア`)
};

const hi_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट शॉर्टकट`)
};

const pt_pt2_shortcut_keys_clear_aria_label = /** @type {(inputs: Shortcut_Keys_Clear_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atalho claro`)
};

/**
* | output |
* | --- |
* | "Clear Shortcut" |
*
* @param {Shortcut_Keys_Clear_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_aria_label = /** @type {((inputs?: Shortcut_Keys_Clear_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_clear_aria_label(inputs)
	if (locale === "de") return de_shortcut_keys_clear_aria_label(inputs)
	if (locale === "it") return it_shortcut_keys_clear_aria_label(inputs)
	if (locale === "ru") return ru_shortcut_keys_clear_aria_label(inputs)
	if (locale === "es") return es_shortcut_keys_clear_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_clear_aria_label(inputs)
	if (locale === "ja") return ja_shortcut_keys_clear_aria_label(inputs)
	if (locale === "hi") return hi_shortcut_keys_clear_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_clear_aria_label(inputs)
	return en_shortcut_keys_clear_aria_label(inputs)
});